import type { FC } from 'react';
import { DialogTitle } from '@headlessui/react';
import { useLanguage } from '@root/src/language';

import { AttachmentRenameController } from '../controller/AttachmentRenameController';

import { AttachmentModal } from './AttachmentModal';

interface AttachmentRenameModalProps {
  attachmentFileName: string;
  attachmentId: string;
  attachmentName: string;
  handleClose: () => void;
}

export const AttachmentRenameModal: FC<AttachmentRenameModalProps> = ({
  attachmentFileName,
  attachmentId,
  attachmentName,
  handleClose,
}) => {
  const { getContent } = useLanguage({ prefix: 'naming.mrc.modals.attachment' });

  return (
    <AttachmentModal handleClose={handleClose}>
      <>
        <DialogTitle as="h3" className="text-info-900! mb-2 text-xl! leading-6">
          {getContent(`title.rename`)}
        </DialogTitle>
        <AttachmentRenameController
          handleClose={handleClose}
          attachmentId={attachmentId}
          attachmentBaseName={attachmentName}
          attachmentFileName={attachmentFileName}
        />
      </>
    </AttachmentModal>
  );
};
